
export class NL_Servis
 {
    ID: number;
    ADRES: string;
    Tanim:string;
   
}


// WEBPACK FOOTER //
// ./src/models/NL_Servis.ts